// Visual error offset: when reconciliation moves the predicted position, the camera keeps its old
// position (offset = old - new) and the offset decays with tau = 80 ms (NETCODE.md). Corrections
// longer than 2 m snap instead.

export const ERROR_TAU_SEC = 0.08;
export const ERROR_SNAP_DIST = 2;

export class VisualError {
  x = 0;
  y = 0;
  z = 0;

  /**
   * Adds the correction `old - new` (m). Returns false (offset cleared) when it is longer than
   * `ERROR_SNAP_DIST`, i.e. the caller should let the camera snap.
   */
  add(dx: number, dy: number, dz: number): boolean {
    const nx = this.x + dx;
    const ny = this.y + dy;
    const nz = this.z + dz;
    if (Math.hypot(dx, dy, dz) > ERROR_SNAP_DIST || Math.hypot(nx, ny, nz) > ERROR_SNAP_DIST) {
      this.clear();
      return false;
    }
    this.x = nx;
    this.y = ny;
    this.z = nz;
    return true;
  }

  /** Exponential decay over `dtSec`. */
  decay(dtSec: number): void {
    if (this.x === 0 && this.y === 0 && this.z === 0) return;
    const k = Math.exp(-dtSec / ERROR_TAU_SEC);
    this.x *= k;
    this.y *= k;
    this.z *= k;
    if (Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) < 1e-4) this.clear();
  }

  length(): number {
    return Math.hypot(this.x, this.y, this.z);
  }

  clear(): void {
    this.x = 0;
    this.y = 0;
    this.z = 0;
  }
}
